<template>
  <div class="editDocument">
    <div class="infoItem">
      <span class="label"> {{ $tt("问题：") }} </span>
      <el-input
        class="form"
        v-model="question"
        :placeholder="$tt('请输入内容')"
        :disabled="justShow"
      ></el-input>
    </div>
    <div class="infoItem">
      <span class="label"> {{ $tt("答案：") }} </span>
      <div class="form editor-wrap">
        <div id="wangEditor"></div>
      </div>
    </div>

    <div class="btns" v-if="!justShow">
      <el-button type="primary" @click="submit">{{ $tt("确认保存") }}</el-button>
      <el-button @click="cancel">{{ $tt("取消") }}</el-button>
    </div>
  </div>
</template>

<script>
import wangEditor from "wangeditor";
import { configureHelpWangEditor } from "@/utils/helpEditor";

export default {
  data() {
    return {
      htmlEditor: null,
      question: "",
      justShow: false,
    };
  },
  mounted() {
    this.initEditor();
    if (this.$route.query.id) {
      this.initEditorData();
    }
  },
  beforeDestroy() {
    if (this.htmlEditor) {
      this.htmlEditor.destroy();
      this.htmlEditor = null;
    }
  },
  methods: {
    initEditor() {
      const { noEdit } = this.$route.query;
      if (noEdit) {
        this.justShow = true;
      }
      this.htmlEditor = new wangEditor("#wangEditor");
      configureHelpWangEditor(this.htmlEditor);
      this.htmlEditor.create();
      if (noEdit) {
        this.htmlEditor.disable();
      }
    },
    initEditorData() {
      this.$request
        .getHelpDocumentInfo({
          id: this.$route.query.id,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          const { question, answer } = res?.data || {};
          this.question = question;
          if (this.htmlEditor) {
            this.htmlEditor.txt.html(answer || "");
          }
        });
    },
    submit() {
      const id = this.$route.query.id;
      this.$request
        .addOrUpdateDocument({
          id: id || undefined,
          question: this.question,
          answer: this.htmlEditor.txt.html(),
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success(id ? this.$tt("保存成功") : this.$tt("新建成功"));
          this.cancel();
        });
    },
    cancel() {
      if (this.justShow) {
        this.$router.push("/helps");
        return;
      }
      this.$router.push("/helpDocuments");
    },
  },
};
</script>

<style lang="scss">
.editDocument {
  background-color: #fff;
  padding: 24px 12%;
  .infoItem {
    display: flex;
    margin-bottom: 20px;
    .label {
      flex-shrink: 0;
      width: 56px;
      text-align: right;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      box-sizing: border-box;
      padding-top: 8px;
      margin-right: 12px;
    }
    .form {
      flex: 1;
      min-width: 0;
    }
    .editor-wrap {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      .w-e-toolbar {
        border-bottom: 1px solid #e8e8e8 !important;
      }
      .w-e-text-container {
        min-height: 320px !important;
      }
    }
  }
  .btns {
    margin-left: 68px;
  }
}
</style>
